/* istanbul ignore file */
import('./bootstrap');

export {};
